import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel, Grid, Typography, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    root: {},
    item: {
        display: 'flex',
        flexDirection: 'column'
    }
});

function Ecg(props) {
    const classes = useStyles();

    return (
        <Grid classes={classes.item} item md={4} sm={6} xs={12}>
            <Typography color="textPrimary" gutterBottom variant="h6">
                ECG
            </Typography>
            {props.loading ? (
                <CircularProgress />
            ) : (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={props.values.ecgEnable}
                            onChange={() => props.setFieldValue('ecgEnable', !props.values.ecgEnable)}
                        />
                    }
                    label="Enable"
                />
            )}
        </Grid>
    );
}

Ecg.propTypes = {
    values: PropTypes.object,
    setFieldValue: PropTypes.func,
    loading: PropTypes.bool
};

export default Ecg;
